import axios from 'axios';
import { toast } from 'sonner';

function getErrorMessage(detail, fallback) {
  if (typeof detail === 'string') {
    return detail;
  }
  if (Array.isArray(detail)) {
    const emailError = detail.find((item) => item?.loc?.includes('email'));
    if (emailError?.msg) {
      return emailError.msg;
    }
    const first = detail[0];
    if (first?.msg) {
      return first.msg;
    }
  }
  return fallback;
}

async function submitWaitlist(endpoint, payload, apiBase, duplicateMessage) {
  const API = `${apiBase}/waitlist/${endpoint}`;
  try {
    await axios.post(API, payload);
    toast.success('Submitted successfully - we\'ll be in touch soon.');
    return true;
  } catch (error) {
    const status = error.response?.status;
    const detail = error.response?.data?.detail;
    if (status === 400 || status === 422) {
      toast.error(getErrorMessage(detail, duplicateMessage));
    } else {
      toast.error('Something went wrong. Please try again later.');
    }
    return false;
  }
}

export function submitStudentWaitlist(payload, apiBase) {
  return submitWaitlist(
    'student',
    payload,
    apiBase,
    'This email is already on the student waitlist.'
  );
}

export function submitFacultyWaitlist(payload, apiBase) {
  return submitWaitlist(
    'faculty',
    payload,
    apiBase,
    'This email is already on the faculty waitlist.'
  );
}
